import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableCsvFreightImport = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableCsvFreightImport);
};
